import { Instagram } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import TikTokIcon from "./TikTokIcon";

export default function SocialLinks({ className = "", idPrefix = "social" }) {
  const { config } = useSite();
  const links = [
    { label: "Instagram", href: (config.social_instagram || "").trim(), icon: Instagram, testid: `${idPrefix}-instagram` },
    { label: "TikTok", href: (config.social_tiktok || "").trim(), icon: TikTokIcon, testid: `${idPrefix}-tiktok` },
  ].filter((l) => l.href);

  if (!links.length) return null;

  return (
    <div className={className} data-testid={`${idPrefix}-area`}>
      <p className="text-sm text-muted-foreground">Urmărește-ne și vezi lucrările noastre</p>
      <div className="mt-3 flex items-center gap-3">
        {links.map(({ label, href, icon: Icon, testid }) => (
          <a
            key={testid}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
            className="inline-flex h-11 w-11 items-center justify-center border border-white/15 text-paper/85 transition-colors duration-300 hover:border-copper hover:text-copper"
            data-testid={testid}
          >
            <Icon className="h-5 w-5" />
          </a>
        ))}
      </div>
    </div>
  );
}
